import React, { useState, useEffect } from "react";
import {
  ButtonOutline,
  TableWarpper,
  Text,
} from "../styledConstants";
 import Pagination from "../../components/common/Pagination";
import {
  Modal,
  Box,
  TextField,
  Button,
  // Pagination,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Switch,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import config from "../../utils/config";
import Request from "../../utils/Request";
import ApiRequest from "../../utils/ApiRequest";
import FilterBox from "../../components/common/FilterBox";
import { getParams } from "../../utils/common";
import { FilterWrapper } from "../../Pages/Merchants/style";
import { toast } from "react-toastify";
import {
  Table,
  ListPageFilterBar,
  Card,
} from "../../v2/design-system";
import { theme } from "../../v2/design-system/theme";

const filterForm = [
  {
    name: "name",
    type: "text",
    value: "",
    placeholder: "Name",
  },
  {
    name: "email",
    type: "text",
    value: "",
    placeholder: "Email",
  },
  {
    name: "mobileNumber",
    type: "text",
    value: "",
    placeholder: "Mobile Number",
  },
  {
    name: "orgCode",
    type: "text",
    value: "",
    placeholder: "Org Code",
  },
  {
    name: "referralCode", 
    type: "text",
    value: "",
    placeholder: "Referral Id",
  },
  {
    name: "orgName",
    type: "text",
    value: "",
    placeholder: "Org Name",
  }
];


function DistributorTable({ variant = "v1" }) {
  const isV2 = variant === "v2";
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [openBankModal, setOpenBankModal] = useState(false);
  const [openMiscModal, setOpenMiscModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [cashbackRow, setCashbackRow] = useState(null);
  const [message, setMessage] = useState({});


  
  // Pagination states
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useState([...filterForm]);



//   const fetchDistributors = async () => {
//   setLoading(true);
//   try {
//     const res = await axios.get(
//       `https://uat-apps.mufinpay.com/api-service/user/api/societiesList?page=${page - 1}&size=${size}`,
//       {
//         headers: {
//           'apikey': 'e9480c57-0bed-45f7-b7d2-79a06w20p', // Replace with your actual API key
//         },
//       }
//     );

//     const rawData = res.data.metaInfo?.data || res.data.data || [];

//     // If current page has no data and it's not the first page, go back one page
//     if (rawData.length === 0 && page > 1) {
//       setPage((prev) => prev - 1);
//       return;
//     }

//     const formattedData = rawData.map((item) => ({
//       id: item.uuId,
//       name: item.name,
//       email: item.email,
//       contact: item.mobileNumber,
//       orgName: item.orgName,
//       orgCode: item.orgCode,
//       vaNumber: item.vaNumber || "Null",
//       // status: item.status || "Active",
//       apiKey: item.apiKey,
//       salt: item.salt,
//       referralId: item.referralId,
//      programManagerName: item.programManagerName || "Null",
//      programManagerCode:item.programManagerCode || "Null",
//     }));
//     setData(formattedData);

//     const total = res.data.metaInfo?.totalItems || res.data.totalItems || 1;
//     setTotalPages(Math.ceil(total / size));
//   } catch (error) {
//     console.error("Error fetching distributor data:", error);
//   } finally {
//     setLoading(false);
//   }
// };
const FilterChangeHandler = (event, index) => {
  const _controls = [...controls];
  const mob = /^[0-9\b]+$/;
  const onlyAlphabets = /^[A-Za-z\s]*$/;

  if (event?.target?.name === "mobileNumber") {
    if (event.target.value === "" || mob.test(event.target.value)) {
      if (event.target.value.length > 10) return;
      _controls[index].value = event.target.value;
      setControls(_controls);
    }
  } else if (event?.target?.name === "name") {
    if (event.target.value === "" || onlyAlphabets.test(event.target.value)) {
      _controls[index].value = event.target.value;
      setControls(_controls);
    }
  } else {
    _controls[index].value = event.target.value;
    setControls(_controls);
  }
};
const searchDistributor = (event) => {
  if (event?.preventDefault) event.preventDefault();
  setPage(1);
  fetchDistributors();
};

const resetFilter = () => {
  filterForm.forEach((obj) => (obj.value = ""));
  setControls([...filterForm]);
  setPage(1);
  fetchDistributors();
};

 const fetchDistributors = () => {
  setLoading(true);

  const successHandler = (res) => {
    const rawData = res.data.metaInfo?.data || res.data.data || [];
    if (rawData.length === 0 && page > 1) {
      setPage((prev) => prev - 1);
      return;
    }
    const formattedData = rawData.map((item) => ({
      id: item.uuId,
      name: item.name,
      email: item.email,
      contact: item.mobileNumber,
      orgName: item.orgName,
      orgCode: item.orgCode,
      vaNumber: item.vaNumber || "Null",
      apiKey: item.apiKey,
      salt: item.salt,
      referralId: item.referralId,
      programManagerName: item.programManagerName || "Null",
      programManagerCode: item.programManagerCode || "Null",
      cashbackRequired: item.cashbackRequired ?? false,
      address: item.address || "-",

    }));
    setData(formattedData);

    const total = res.data.metaInfo?.totalItems ?? res.data.totalItems ?? 0;
    setTotalElements(total);
    setTotalPages(Math.max(1, Math.ceil((total || 1) / size)));

    setLoading(false);
  };

  const errorHandler = (error) => {
    console.error("Error fetching society partner data:", error);
    setLoading(false);
  };

  const api = new ApiRequest("", successHandler, errorHandler, false);
  
  const params = getParams(controls);
  const payload = {
    pagination: { pageNo: page, pageSize: size },
    ...params, // 👈 include filters in payload
  };
   console.log("Payload sent:", payload);
  return api.post(`${config.apis.admin.SOCIETY_LIST}`, payload);
};
  useEffect(() => {
    fetchDistributors();
  }, [page, size]);

  const bankValidationSchema = Yup.object({
    bankName: Yup.string().required("*Bank name is required"),
    accountNumber: Yup.string().required("*Account number is required"),
    accountHolderName: Yup.string().required("*Account holder name is required"),
    ifscCode: Yup.string().required("*IFSC code is required"),
    beneId: Yup.string().required("*Bene ID is required"),
  });

  const miscValidationSchema = Yup.object({
    webhookUrl: Yup.string().url("Invalid URL").required("Webhook URL is required"),
    ip: Yup.string().required("IP address is required"),
  });

  const formik = useFormik({
    initialValues: {
      bankName: "",
      accountNumber: "",
      accountHolderName: "",
      ifscCode: "",
      beneId: "",
    },
    validationSchema: bankValidationSchema,
    onSubmit: (values) => {
      console.log("Bank Form Submitted:", values);
      alert("Bank details saved!");
      handleClose();
    },
  });

  const miscFormik = useFormik({
    initialValues: {
      webhookUrl: "",
      ip: "",
    },
    validationSchema: miscValidationSchema,
    onSubmit: (values) => {
      console.log("Miscellaneous Form Submitted:", values);
      alert("Miscellaneous info saved!");
      handleClose();
    },
  });
   
  const handleCashbackToggle = (row) => {
    console.log("rwoo",row.id);
  setCashbackRow(row);
  setConfirmOpen(true);
};

  const handleBankOpen = (row) => {
    setSelectedRow(row);
    setOpenBankModal(true);
  };

  const handleMiscOpen = (row) => {
    setSelectedRow(row);
    setOpenMiscModal(true);
  };

  const handleClose = () => {
    setOpenBankModal(false);
    setOpenMiscModal(false);
    setSelectedRow(null);
    formik.resetForm();
    miscFormik.resetForm();
  };
   
 const updateCashbackStatus = (row) => {
  if (!row) return;

  const successHandler = (res) => {
    if (res?.data?.message === "Society cashback updated successfully") {
      if (isV2) {
        toast.success("Cashback status updated.");
      } else {
      setMessage({ success: "CASHBACK STATUS UPDATED SUCCESSFULLY" });
      }

      // Update UI locally
      setData((prev) =>
        prev.map((item) =>
          item.id === row.id
            ? { ...item, cashbackRequired: !item.cashbackRequired }
            : item
        )
      );

      setConfirmOpen(false);
      setCashbackRow(null);
      fetchDistributors();
    } else {
      const errMsg = res?.msg || "Something went wrong";
      setMessage({ error: errMsg });
    }
  };

  const errorHandler = () => {
    if (isV2) toast.error("Failed to update cashback status");
    else setMessage({ error: "Failed to update cashback status" });
  };

  // Create API request instance
  const api = new ApiRequest("", successHandler, errorHandler, false);

  const payload = {
    uuid: row.id,
    cashbackRequired: !row.cashbackRequired,
  };

 

  // Call POST API
  return api.post(`${config.apis.admin.UPDATE_CASH_BACK}`, payload);
};

  return (
    <div>
      <FilterWrapper>
       <FilterBox
         filterForm={controls}
         onFilterChange={FilterChangeHandler}
         onFilterSubmit={searchDistributor}
         refreshPage={resetFilter}
       />
       </FilterWrapper>

      <TableWarpper className="mt24">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" py={5}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <table className="table">
              <thead>
                <tr>
                  <th className="text-left"><Text size="rg" fw="medium">Name</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Email</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Contact</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Org Name</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Org Code</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">VA No.</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Referral Id </Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Api key</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Salt Key</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Program Manager Name</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Program Manager Code</Text></th>
                  <th className="text-left"><Text size="rg" fw="medium">Address</Text></th>
                  {/* <th className="text-left"><Text size="rg" fw="medium">Cashback</Text></th> */}
                  <th className="text-left"><Text size="rg" fw="medium">Actions</Text></th>

                  {/* <th className="text-left"><Text size="rg" fw="medium">Status</Text></th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td className="text-left" >{item.name}</td>
                    <td className="text-left">{item.email}</td>
                    <td className="text-left">{item.contact}</td>
                    <td className="text-left">{item.orgName}</td>
                    <td className="text-left">{item.orgCode}</td>
                    <td className="text-left">{item.vaNumber}</td>
                    <td className="text-left">{item.referralId}</td>
                    <td className="text-left">{item.apiKey}</td>
                    <td className="text-left">{item.salt}</td>
                    <td className="text-left">{item.programManagerName}</td>    
                    <td className="text-left">{item.programManagerCode}</td>  
                    <td className="text-left">{item.address}</td>  
                    {/* <td className="text-left">
                    <Switch
                      checked={item.cashbackRequired}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCashbackToggle(item);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': { color: "#16a34a" },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: "#16a34a" }
                      }}
                    />
                  </td> */}
                    <td className="text-left">
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => navigate("/society-partner-details", { state: item })}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          borderRadius: "8px",
                          background: "linear-gradient(135deg, #390095 0%, #6630d2 100%)",
                          boxShadow: "0 2px 8px rgba(57, 0, 149, 0.35)",
                        }}
                      >
                        View
                      </Button>
                    </td>

                    {/* <td className="text-left">
                      <span className={`px-2 py-1 rounded text-white ${item.status === "Active" ? "bg-green-500" : "bg-red-500"}`}>
                        {item.status}
                      </span>
                    </td> */}
                  </tr>
                ))}
              </tbody>
              <tfoot>
    <tr>
      <td colSpan={14}>
        <Box display="flex" justifyContent="start" alignItems="center" mt={2}>
        <FormControl variant="standard" sx={{ minWidth: 100 ,pl: 3 }}>
                <InputLabel sx={{ pl: 4 }}>Items</InputLabel>
                <Select value={size} onChange={(e) => setSize(Number(e.target.value))} label="Rows">
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl> 
          {/* <ItemPerPage
            pageSize={size}
            getPageSize={(pageSize) => {
              setSize(pageSize);
              setPage(1); // reset to first page when size changes
            }}
          /> */}
          <Pagination
            totalPages={totalPages}
            currentPage={page}
            getCurrentPageData={(curPage) => {
              setPage(curPage);
            }}
          />
        </Box>
      </td>
    </tr>
  </tfoot>
            </table>

          
            {/* <Box mt={3} display="flex" justifyContent="space-between" alignItems="center"> */}
              {/* <FormControl variant="standard" sx={{ minWidth: 100 }}>
                <InputLabel>Rows</InputLabel>
                <Select value={size} onChange={(e) => setSize(Number(e.target.value))} label="Rows">
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                </Select>
              </FormControl> */}
              
                 {/* <ItemPerPage
                 pageSize={size}
                 getPageSize={(pageSize) => {
                  setSize(pageSize);
                 }}
               />
               <Pagination
              totalPages={totalPages}
              currentPage={page}
              getCurrentPageData={(curpage) => {
                setLoading(true);
                setPage(curpage);
              }}
               />
            </Box> */}
          </>
        )}
      </TableWarpper>

      {/* Bank Modal */}
      <Modal open={openBankModal} onClose={handleClose}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 500, bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2 }}>
          <h2>Add Bank Info</h2>
          <form onSubmit={formik.handleSubmit}>
            <TextField fullWidth margin="normal" label="Bank Name" name="bankName" value={formik.values.bankName} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.bankName && Boolean(formik.errors.bankName)} helperText={formik.touched.bankName && formik.errors.bankName} />
            <TextField fullWidth margin="normal" label="Account Number" name="accountNumber" value={formik.values.accountNumber} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)} helperText={formik.touched.accountNumber && formik.errors.accountNumber} />
            <TextField fullWidth margin="normal" label="Account Holder Name" name="accountHolderName" value={formik.values.accountHolderName} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.accountHolderName && Boolean(formik.errors.accountHolderName)} helperText={formik.touched.accountHolderName && formik.errors.accountHolderName} />
            <TextField fullWidth margin="normal" label="IFSC Code" name="ifscCode" value={formik.values.ifscCode} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)} helperText={formik.touched.ifscCode && formik.errors.ifscCode} />
            <TextField fullWidth margin="normal" label="Bene ID" name="beneId" value={formik.values.beneId} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.beneId && Boolean(formik.errors.beneId)} helperText={formik.touched.beneId && formik.errors.beneId} />
            <Box mt={2} display="flex" justifyContent="space-between">
              <Button variant="contained" color="error" onClick={handleClose}>Cancel</Button>
              <Button variant="contained" color="success" type="submit">Save</Button>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Misc Modal */}
      <Modal open={openMiscModal} onClose={handleClose}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2 }}>
          <h2>Add Miscellaneous Info</h2>
          <form onSubmit={miscFormik.handleSubmit}>
            <TextField fullWidth margin="normal" label="Webhook URL" name="webhookUrl" value={miscFormik.values.webhookUrl} onChange={miscFormik.handleChange} onBlur={miscFormik.handleBlur} error={miscFormik.touched.webhookUrl && Boolean(miscFormik.errors.webhookUrl)} helperText={miscFormik.touched.webhookUrl && miscFormik.errors.webhookUrl} />
            <TextField fullWidth margin="normal" label="IP Address" name="ip" value={miscFormik.values.ip} onChange={miscFormik.handleChange} onBlur={miscFormik.handleBlur} error={miscFormik.touched.ip && Boolean(miscFormik.errors.ip)} helperText={miscFormik.touched.ip && miscFormik.errors.ip} />
            <Box mt={2} display="flex" justifyContent="space-between">
              <Button variant="contained" color="error" onClick={handleClose}>Cancel</Button>
              <Button variant="contained" color="success" type="submit">Save</Button>
            </Box>
          </form>
        </Box>
      </Modal>
      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 350,
      bgcolor: "background.paper",
      p: 3,
      borderRadius: 2,
      textAlign: "center",
    }}
  >
    <h3>Are you sure?</h3>
    <p>Do you want to update cashback status?</p>

    <Box mt={3} display="flex" justifyContent="space-between">
      <Button
        variant="contained"
        color="error"
        onClick={() => setConfirmOpen(false)}
      >
        Cancel
      </Button>

      <Button variant="contained" color="success" onClick={() => updateCashbackStatus(cashbackRow)}>
        Yes, Update
      </Button>
    </Box>
  </Box>
</Modal>

    </div>
  );
}

export default DistributorTable;
